import { Component, Vue, Watch } from 'vue-property-decorator';
import { Action, Getter, Mutation } from 'vuex-class';
import DashboardSidebar from '@/components/dashboardSidebar/dashboardSidebar.vue';
import DashboardSidebarMobile from '@/components/dashboardSidebarMobile/dashboardSidebarMobile.vue';

@Component({
  beforeRouteEnter(to: any, from: any, next: any) {
    next((vm) => {
      if(vm.getIsToken && !vm.getSubscription) {
        next('/mi-menu/comenzar');
      } else {
        next();
      }
    });
  },
  components:{
    DashboardSidebar,
    DashboardSidebarMobile
  }

})
export default class SubscriptionsDashboard extends Vue {

  @Getter getSubscription

 
  // Modal Test
  openModal = false;
  openEditModal = false;
  openFilterDropdown = false;
  openOrderDropdown = false;


  // For Pagination
  pageSize = 8;
  currentPage = 1;

  pedidos = [
      {
        id: 1,
        name: 'Mar 15 de Febrero',
        label: 'Pedido actual',
        status: 'Confirmado',
        color: 'green',
        tab_status: true
      },
      {
        id: 2,
        name: 'Mar 22 de Febrero',
        label: 'Próximo Pedido',
        status: 'Abierto',
        color: 'yellow',
        tab_status: false
      }
  ]

  openCollapsible(id: any) {
    let content = document.getElementsByClassName('collapsible-content-'+id)[0]  as HTMLElement;

    if (content.style.maxHeight) {
      content.style.maxHeight = null;
      content.style.marginTop = null;
    } else {
      content.style.maxHeight = content.scrollHeight + "px";
      content.style.marginTop = 0.6 + 'rem'
    }


  }

  setActiveTab(id: any) {

    this.pedidos.forEach((pedido,index) => {
        pedido.tab_status = false;
    })

    this.pedidos[id].tab_status = true;
  }
  
}
